import React from 'react';
import { SelectableFilters, truncateAppliedFilters } from '../../../jobs/filterComponents/SelectableFilters';
import type { FilterComponentProps } from '../../../jobs/filterComponents/types';

export type LlmModeOption = 'Off' | 'Ethernet Client' | 'Ethernet Server' | 'WiFi Client' | 'WiFi Server' | 'Unknown';

type LlmModeFilterValues = Record<LlmModeOption, boolean>;

const defaultFilters: LlmModeFilterValues = {
  Off: false,
  'Ethernet Client': false,
  'Ethernet Server': false,
  'WiFi Client': false,
  'WiFi Server': false,
  Unknown: false,
};

function renderValues(value: [string, boolean][]): string {
  return truncateAppliedFilters(value.flatMap(([filterKey, filterApplied]) => (filterApplied ? [filterKey] : [])));
}

export const LlmModeFilters: React.FC<FilterComponentProps> = ({ columnDef, onFilterChanged }) => (
  <SelectableFilters<LlmModeOption, LlmModeFilterValues>
    columnDef={columnDef}
    defaultFilters={defaultFilters}
    onFilterChanged={onFilterChanged}
    options={[
      ['Off', 'Off'],
      ['Ethernet Client', 'Ethernet Client'],
      ['Ethernet Server', 'Ethernet Server'],
      ['WiFi Client', 'WiFi Client'],
      ['WiFi Server', 'WiFi Server'],
      ['Unknown', 'Unknown'],
    ]}
    renderValues={renderValues}
  />
);
